import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { MessageService } from '../../shared/services/message.service';
import { LeftSidebarComponent } from '../../shared/left-sidebar/left-sidebar.component';

const MONTH_NAMES = [
  'Januar',
  'Februar',
  'Mart',
  'April',
  'Maj',
  'Jun',
  'Jul',
  'Avgust',
  'Septembar',
  'Oktobar',
  'Novembar',
  'Decembar',
];

@Component({
  selector: 'app-monthly-stats',
  standalone: true,
  imports: [LeftSidebarComponent, DecimalPipe],
  templateUrl: 'monthly-stats.component.html',
})
export class MonthlyStatsComponent implements OnInit {
  private messageService = inject(MessageService);
  stats = signal<any[]>([]);

  sortedStats = computed(() =>
    [...this.stats()].sort((a, b) => b.record_year - a.record_year || b.record_month - a.record_month),
  );

  totalRecords = computed(() => this.stats().reduce((sum, stat) => sum + stat.total_records, 0));

  maxRecords = computed(() => this.stats().reduce((max, stat) => Math.max(max, stat.total_records), 0));

  ngOnInit() {
    this.loadMonthStats();
  }

  loadMonthStats() {
    this.messageService.getMonthlyStats().subscribe({
      next: (data) => this.stats.set(data.stats),
      error: (err) => console.error(err),
    });
  }

  monthName(month: number): string {
    return MONTH_NAMES[month - 1] ?? month.toString();
  }
}
